import * as yup from "yup"
import { numberOnly, passwordStructure } from "./constants"

export const signUpSchemaFCMB = yup.object({
  accountNumber: yup
    .string()
    .min(10, "Account number is a minimum of 10 digits")
    .max(10, "Account number is a maximum of 10 digits")
    .required("Account Number is a required field")
    .matches(numberOnly, "Account number can only contain numbers"),
  password: yup
    .string()
    .required("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .matches(
      passwordStructure,
      "Must contain one uppercase, one lowercase, one number and one special-case character",
    ),
  confirmPassword: yup
    .string()
    .required("Confirm new password")
    .oneOf([yup.ref("password"), null], "Password does not match"),
})

export const signUpSchemaNonFCMB = yup.object({
  email: yup.string().required("Enter email").email("Invalid email"),
  password: yup
    .string()
    .required("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .matches(
      passwordStructure,
      "Must contain one uppercase, one lowercase, one number and one special-case character",
    ),
  confirmPassword: yup
    .string()
    .required("Confirm new password")
    .oneOf([yup.ref("password"), null], "Password does not match"),
})

export const loginSchema = yup.object({
  email: yup.string().required("Enter email").email("Invalid email"),
  password: yup
    .string()
    .required("Enter your password")
    .min(8, "Password should be of minimum 8 characters length"),
})

export const resetPasswordSchema = yup.object({
  password: yup
    .string()
    .required("Enter new password")
    .min(8, "Password should be of minimum 8 characters length")
    .matches(
      passwordStructure,
      "Must contain  one uppercase, lowercase, number and special character",
    ),
  confirmPassword: yup
    .string()
    .required("Confirm new password")
    .oneOf([yup.ref("password"), null], "Password does not match"),
})

export const changePasswordSchema = yup.object({
  oldPassword: yup
    .string()
    .required("Enter your current password")
    .min(8, "Password should be of minimum 8 characters length"),
  newPassword: yup
    .string()
    .required("Enter new password")
    .notOneOf([yup.ref("oldPassword"), null], "New password cannot be the same as the old one")
    .min(8, "Password should be of minimum 8 characters length")
    .matches(
      passwordStructure,
      "Must contain one uppercase, one lowercase, one number and one special-case character",
    ),
  confirmPassword: yup
    .string()
    .required("Confirm new password")
    .oneOf([yup.ref("newPassword"), null], "Password does not match"),
})

export const addBankSchema = yup.object({
  bankName: yup.string().required("Select your bank"),
  accountNumber: yup
    .string()
    .min(10, "Account number is a minimum of 10 digits")
    .max(10, "Account number is a maximum of 10 digits")
    .required("Account Number is a required field")
    .matches(numberOnly, "Account number can only contain numbers"),
})

export const createInvStep3Schema = yup.object({
  topUpPeriod: yup.string(),
  interest: yup.string().required("Select your interest"),
  maturity: yup.string().required("Select your maturity option"),
  account: yup.string().required("Select your account"),
})

export const dollarAccountFormSchema = yup.object({
  bankName: yup.string().required("Enter bank name").min(3, "Enter a valid bank name"),
  accountName: yup.string().required("Enter account name").min(3, "Enter a valid account name"),
  accountNumber: yup
    .string()
    .required("Enter account number")
    .min(5, "Enter a valid account number"),
  ibanNumber: yup.string().required("Enter your bank's IBAN number"),
  swiftCode: yup.string().required("Enter your bank's swift code"),
})

export const cardFormSchema = yup.object({
  pan: yup
    .string()
    .required("Enter your card number")
    .min(16, "Invalid card number")
    .max(16, "Invalid card number"),
  cvv: yup.string().required("Enter your cvv").min(3, "Invalid cvv").max(3, "Invalid cvv"),
  expDate: yup.string("Select card expiry date").required("Select card expiry date").nullable(),
})

export const cardPinSchema = yup.object({
  pin: yup.string().required("Enter your card pin").min(4, "Invalid pin").max(4, "Invalid pin"),
})

export const newsLetterSchema = yup.object({
  name: yup
    .string()
    .required("Enter your name")
    .min(3, "Name should be of minimum 3 characters length"),
  email: yup.string().required("Enter email").email("Invalid email"),
})
